module.exports = __webpack_public_path__ + "b545f0566a7a483638b3dcafd641d475.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-openx.png
// module id = 637
// module chunks = 0